import setValue from './setValue'

export default url => dispatch => dispatch(setValue('bookingUrl', url))
